export { default as GroupListingPage } from './components/GroupListingPage';

export const GroupListingPageDynamic = () => import('./components/GroupListingPage');
